import CyberSource from './customCyberSource';
import DeliveryType from './customDeliveryType';
import GiftCard from './customGiftCard';
import GuestValidateEmail from './customGuestValidateEmail';
import HdDetails from './customHdDetails';
import HdmCart from './customHdmCart';
import Location from './customLocation';
import OrderStatus from './customOrderStatus';
import DeliveryDetails from './customDeliveryDetails';
import OrderHistoryStatus from './customOrderHistoryStatus';
import RecentOrders from './customRecentOrders';
import StoreView from './customStoreView';
import PayPal from './customPayPal';
import PhysicalStore from './customPhysicalStore';
import PromotionDetails from './customPromotionDetails';
import SetDefaultStore from './customSetDefaultStore';
import PhysicalStoreCart from './customPhysicalStoreCart';
import TotalValidate from './customTotalValidate';


export const customCyberSource = CyberSource;
export const customDeliveryType = DeliveryType;
export const customGiftCard = GiftCard;
export const customGuestValidateEmail = GuestValidateEmail;
export const customHdDetails = HdDetails;
export const customHdmCart = HdmCart;
export const customLocation = Location;
export const customOrderStatus = OrderStatus;
export const customDeliveryDetails = DeliveryDetails;
export const customOrderHistoryStatus = OrderHistoryStatus;
export const customRecentOrders = RecentOrders;
export const customStoreView = StoreView;
export const customPayPal = PayPal;
export const customPhysicalStore = PhysicalStore;
export const customPromotionDetails = PromotionDetails;
export const customSetDefaultStore = SetDefaultStore;
export const customPhysicalStoreCart = PhysicalStoreCart;
export const customTotalValidate = TotalValidate;
